export default [
    { text: 'Nome do cliente', sortable: false, value: 'name' },
    { text: 'Documento', sortable: false, value: 'document', align: 'center' },
    { text: 'Notas', sortable: false, value: 'notasTotal', align: 'center', width: 80, },
    { text: 'Valor', sortable: false, value: 'value', align: 'center', width: 160 },
    { text: 'Data', sortable: false, value: 'date', align: 'center', width: 144 },
];
